import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

const DashboardLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const sidebarRef = useRef();

  // Fermer le menu mobile lorsqu'on change de route
  useEffect(() => {
    setSidebarOpen(false);
  }, [location]);

  // Fermer en cliquant à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        sidebarOpen
      ) {
        setSidebarOpen(false);
      }
    };
    if (sidebarOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [sidebarOpen]);

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div
        ref={sidebarRef}
        className={`fixed z-30 inset-y-0 left-0 w-64 bg-white shadow-md transform ${
          sidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } transition-transform duration-200 ease-in-out md:translate-x-0 md:static md:inset-0`}
      >
        <div className="p-6">
          <h2 className="text-2xl font-bold text-blue-600 mb-6">AmplifyMyCom</h2>
          <nav className="flex flex-col gap-4 text-gray-700 font-medium">
            <Link to="/dashboard">🏠 Dashboard</Link>
            <Link to="/dashboard/scheduled">📅 Programmés</Link>
            <Link to="/dashboard/history">🕓 Historique</Link>
            <Link to="/dashboard/profile">👤 Profil</Link>
          </nav>
        </div>
      </div>

      {/* Contenu principal */}
      <div className="flex flex-col flex-1 overflow-hidden">
        {/* Barre du haut */}
        <header className="flex items-center justify-between bg-white shadow px-4 py-3 md:py-4 md:px-6">
          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="md:hidden text-gray-700 focus:outline-none"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2}>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d={
                  sidebarOpen
                    ? 'M6 18L18 6M6 6l12 12'
                    : 'M4 6h16M4 12h16M4 18h16'
                }
              />
            </svg>
          </button>
          <span className="text-sm text-gray-600">Espace Client</span>
        </header>

        {/* Contenu de page */}
        <main className="flex-1 overflow-y-auto p-4 sm:p-6">{children}</main>
      </div>
    </div>
  );
};

export default DashboardLayout;
